module.exports = __webpack_public_path__ + "img/tv-fill.dd84112b.svg";